module.exports = __webpack_public_path__ + "img/SUP2.066af434.jpg";